var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFontUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3079 13H10.1041L8.84567 9.55985H3.46617L2.20514 13H0L4.95431 0H7.35356L12.3079 13ZM4.07093 7.90898H8.2409L6.21138 2.3616H6.10442L4.07093 7.90898Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8394 3.94037L16.3312 0.394195C16.1172 0.177829 15.77 0.177829 15.556 0.394195L12.0478 3.94046C11.8336 4.15687 11.8336 4.50769 12.0478 4.7241C12.1547 4.83226 12.2951 4.88638 12.4354 4.88638C12.5757 4.88638 12.7159 4.83226 12.823 4.7241L15.3954 2.12375V8.61547C15.3954 8.92147 15.6409 9.16958 15.9436 9.16958C16.2462 9.16958 16.4918 8.92147 16.4918 8.61547V2.12371L19.0642 4.72397C19.2783 4.94033 19.6254 4.94033 19.8394 4.72397C20.0535 4.5076 20.0535 4.15678 19.8394 3.94037Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontUp);
export default __webpack_public_path__ + "static/media/FontUp.8022a92f344625e6df7368da8e80f340.svg";
export { ForwardRef as ReactComponent };